import type { Iteration } from '@gonfalon/experiments/types';
import { ExperimentStatusKind } from '@gonfalon/experiments/types';

export function getExperimentExposuresChartEmptyState(iterationStatus: Iteration['status'] | undefined): {
  emptyStateTitle: string;
  emptyStateSubtitle: string;
} {
  if (iterationStatus === ExperimentStatusKind.NOT_STARTED) {
    return {
      emptyStateTitle: 'No exposures yet',
      emptyStateSubtitle: 'Exposures will appear after you start the iteration',
    };
  }

  return {
    emptyStateTitle: 'No exposures yet',
    emptyStateSubtitle: '',
  };
}
